import type { ModuleInstance } from "ee/constants/ModuleInstanceConstants";

export const generateModuleInstance = (
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  moduleInstance: ModuleInstance,
  // TODO: Fix this the next time the file is edited
  // eslint-disable-next-line @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any
  moduleInstanceEntities: any,
) => {
  return {
    configEntity: null,
    unEvalEntity: null,
  };
};
